import { createContext, useContext, useState, useCallback, useEffect } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ModulesContext = createContext(null);

// Canonical order + route mapping for the four per-entity ledger modules.
export const MODULE_ORDER = ["prepayments", "accruals", "deferred_income", "fixed_assets"];
export const LEDGER_ROUTE_MODULE = {
  "/prepayments": "prepayments",
  "/accruals": "accruals",
  "/deferred-income": "deferred_income",
  "/fixed-assets": "fixed_assets",
};

export function ModulesProvider({ children }) {
  const { user } = useAuth();
  const [modules, setModules] = useState(null);
  const [labels, setLabels] = useState({});
  const [tenantId, setTenantId] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!user || typeof user !== "object" || user.role === "superadmin") {
      setModules(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/entity/modules");
      setModules(data.modules || null);
      setLabels(data.labels || {});
      setTenantId(data.active_tenant_id || null);
    } catch {
      setModules(null);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    const h = () => load();
    window.addEventListener("modules:refresh", h);
    return () => window.removeEventListener("modules:refresh", h);
  }, [load]);

  return (
    <ModulesContext.Provider value={{ modules, labels, tenantId, loading, refresh: load }}>
      {children}
    </ModulesContext.Provider>
  );
}

export const useModules = () =>
  useContext(ModulesContext) || { modules: null, labels: {}, tenantId: null, loading: true, refresh: () => {} };
